import React from "react";

export default function Footer() {
  return (
    <>
      <div className="tp-footer-2-area black-bg pt-100 pb-20 bg-black">
        <div className="container container-1780">
          <div className="row gap-5">
            <div className="col-xl-5 col-lg-5 col-md-6">
              <div className="tp-footer-2-widget footer-col-2-1">
                <div className="tp-footer-2-widget-logo">
                  <a href="/">
                    <img
                      src="assets/img/one/kryptogram_white_logo.svg"
                      alt=""
                    />
                  </a>
                </div>
                <div className="tp-footer-2-widget-text">
                  <p>
                    Kryptogram is the first-ever NFT-backed real estate &
                    blockchain festival experience. Secure your spot on
                    Kryptogram Island, own real land, and get exclusive access
                    to Tribe O Crypto.
                  </p>
                </div>
              </div>
              <div className="tp-team-4-social pt-20 pb-10">
                <a
                  target="_blank"
                  href="https://www.instagram.com/tribeocrypto/"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a target="_blank" href="https://x.com/tribeocrypto">
                  <i className="fa-brands fa-twitter"></i>
                </a>
                <a target="_blank" href="https://www.youtube.com/@TribeOCrypto">
                  <i className="fa-brands fa-youtube"></i>
                </a>
                <a target="_blank" href="https://medium.com/@tribeocrypto">
                  <i className="fa-brands fa-medium"></i>
                </a>
              </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6">
              <div className="tp-footer-2-widget footer-col-2-2">
                <div className="tp-footer-2-widget-menu">
                  <h4 className="tp-footer-2-widget-title">About Us</h4>
                  <ul>
                    <li>
                      <a href="/about-us">About Kryptogram</a>
                    </li>
                    <li>
                      <a href="https://tribeocrypto.com/" target="_blank">
                        Tribe O Crypto Festival
                      </a>
                    </li>

                    <li>
                      <a href="/roadmap">Roadmap</a>
                    </li>
                    <li>
                      <a href="/faq">FAQs</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6">
              <div className="tp-footer-2-widget footer-col-2-2">
                <div className="tp-footer-2-widget-menu">
                  <h4 className="tp-footer-2-widget-title">Quicklinks</h4>
                  <ul>
                    <li>
                      <a href="/account"> Wallet Connection Guide</a>
                    </li>
                    <li>
                      <a href="/buy-nft">Buy Kryptogram NFTs</a>
                    </li>
                    <li>
                      <a href="#">Partners & Sponsorships</a>
                    </li>
                    <li>
                      <a href="/buy-nft">NFT Benefits</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="tp-copyright-2-area tp-copyright-2-bdr-top bg-black">
            <div className="container container-1480">
              <div className="row align-items-center">
                <div className="col-xl-4 col-lg-5">
                  <div className="tp-copyright-2-left text-center text-lg-start">
                    <p>All rights reserved — © 2025 Kryptogram</p>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-7">
                  <div className=" text-center text-lg-end">
                    <a className="a-tag mx-sm-5 " href="/privacy-policy">
                      Privacy Policy
                    </a>
                    <a className="a-tag ms-3" href="/terms-and-conditions">
                      Terms & Conditions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
